<div class="w-full">
  <app-page-header [title]="title || 'Pages'" />
  <div class="flex flex-wrap justify-start gap-4">
    @for (card of cardslist; track $index) {
      <app-custom-card
        [icon]="card.icon"
        [link]="card.link"
        [title]="card.title | transloco"
        [text]="card.text && card.text | transloco"
        [style]="card.style"
      />
    }
  </div>
</div>
